import { useEffect, useState } from 'react'
import { Dialog, DialogContent } from '@material-ui/core'
import { useSelector } from 'react-redux'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'

const WelcomeMessageModal = () => {
  const providerSelected = useSelector((state) => state.provider)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    if (
      providerSelected.welcomeMessage &&
      providerSelected.welcomeMessage !== '' &&
      providerSelected.welcomeMessage !== null &&
      providerSelected.welcomeMessage !== '<p></p>'
    )
      setIsModalOpen(true)
  }, [providerSelected.welcomeMessage])

  return (
    <Dialog open={isModalOpen} onClose={handleCloseModal} maxWidth={'sm'} fullWidth={true}>
      <DialogContent>
        <div dangerouslySetInnerHTML={{ __html: providerSelected.welcomeMessage }} />
        <SaveOrCancelButtons onCancel={handleCloseModal} />
      </DialogContent>
    </Dialog>
  )
}

export default WelcomeMessageModal
